﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

export const uri = (
    subjectIdentifier: string,
    subjectIdentifierType: string
): string => {
    return `api/Guide/v1/Subjects?subjectIdentifier=${encodeURIComponent(subjectIdentifierType + "|" + subjectIdentifier)}`;
};

export const method = "GET";
